const parseQuantityValue = value =>
  parseInt(String(value).replace(/\D/g, ''), 10);

const parseInputQuantity = els => {
  let total = 0;
  els.each( function(){ 
    const isBasic = $(this).closest('[data-basic="1"]').lenght;
    // basic product qty is set dynamically
    total += parseQuantityValue( $(this).val() ) 
  } );
  return total;
}

export { parseInputQuantity, parseQuantityValue };
